import AddressSearch from 'components/AddressSearch';
import Loading from 'components/Loading';
import styled from 'styled-components';
import RenderAfterNavermapsLoaded from 'utils/RenderAfterNavermapsLoaded';
import BuyingMap from './BuyingMap';

const BuyingMapHome = () => {
  return (
    <Container>
      <AddressSearch />
      <RenderAfterNavermapsLoaded
        ncpClientId={process.env.REACT_APP_NAVER_MAP_KEY}
        error={<Loading />}
        loading={<Loading />}
      >
        <BuyingMap />
      </RenderAfterNavermapsLoaded>
    </Container>
  );
};

export default BuyingMapHome;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
`;
